(function($) {

var pageId = 'page-payer-settings',
  page = '#' + pageId;

$(function() {
  $(document).on('ajax:beforeSend', page + ' .form-payer-settings', function(e, xhr, settings) {
    var membersGuid = $('.member.selected').map(function() {
      return $(this).data('guid');
    }).get();

    settings.data += "&member_guids=" + membersGuid.join(",");
  });
});

$(document).on('pjaxload#' + pageId, function(e, $page, page) {
  tower.initManageMembers($page);
});

})(jQuery);
